import { render } from "./Navbar.vue?vue&type=template&id=395d5bbd"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mobile/Navbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "395d5bbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('395d5bbd', __exports__)) {
    api.reload('395d5bbd', __exports__)
  }
  
  module.hot.accept("./Navbar.vue?vue&type=template&id=395d5bbd", () => {
    api.rerender('395d5bbd', render)
  })

}


export default __exports__